(function ($) {
    'use strict';

    /**
     * Add/refresh unordered queue
     * @type {object}
     * @private
     */
    var _secQueue = {};

    /**
     * Hash of added `sec`
     * @type {object}
     * @private
     */
    var _addedSecHash = {};

    /**
     * Hash of element config. Hash key is type and selector
     * @type {Array}
     * @private
     */
    var _elementConfigsHash = {};

    /**
     * Get element config by type & value
     * @param {string} type
     * @param {string|number} value
     * @private
     */
    function _getElementConfigByValue(type, value) {
        var _elementConfig;
        for (var key in _elementConfigsHash) { // jshint ignore:line
            _elementConfig = _elementConfigsHash[key];

            if (_elementConfig.type === type && _elementConfig.value === value) {
                return _elementConfig;
            }
        }

        return {};
    }

    /**
     * Gather all element config into `_elementConfigs`
     * @param elementConfig
     * @private
     */
    function _storeElementConfig(elementConfig) {
        var hashKey = elementConfig.type + '_' + elementConfig.selector;

        _elementConfigsHash[hashKey] = elementConfig;
    }

    /**
     * Validate if config object has the required props
     * @param {object} elementConfig
     * @private
     */
    function _validateElementConfig(elementConfig) {
        var errors = [];

        if (!elementConfig.type) {
            errors.push('"type" property is required.');
        }

        if (['sec', 'subsec', 'elm', 'slk', 'itc', 'g'].indexOf(elementConfig.type) === -1) {
            errors.push('"type" property must be either "sec", "subsec", "elm", "slk", "itc" or "g"');
        }

        if (['sec', 'subsec', 'elm', 'itc', 'g'].indexOf(elementConfig.type) >= 0
            && !elementConfig.value && elementConfig.value !== 0 // jshint ignore:line
            && !elementConfig.valueFromAttribute) { // jshint ignore:line
            errors.push('either "value" or "valueFromAttribute" property is required.');
        }

        if (!elementConfig.selector) {
            errors.push('"selector" property is required.');
        }

        if (errors.length > 0) {
            errors = ['[Rapid] element config ' + JSON.stringify(elementConfig) + ':'].concat(errors);
            console.warn(errors.join("\n"));
        }

        return errors.length === 0;
    }

    /**
     * Add `sec` object to queue
     * @param secObject
     * @private
     */
    function _addSecToQueue(secObject) {
        var secValue = secObject[Object.keys(secObject)[0]];

        _secQueue[secValue] = secObject;
    }

    /**
     * Process the queue and add/refresh the module
     * @private
     */
    function _registerModules() {
        var activateQueue = {};
        var activateViewabilityQueue = {};

        for (var i in _secQueue) { // jshint ignore:line
            var module = _secQueue[i];
            var moduleId = Object.keys(module)[0];
            var moduleValue = module[moduleId];
            var elementConfig = _getElementConfigByValue('sec', moduleValue);

            if (!_addedSecHash[moduleValue]) {
                if (elementConfig.useViewability === false) {
                    activateQueue = Object.assign(activateQueue, module);
                } else {
                    activateViewabilityQueue = Object.assign(activateViewabilityQueue, module);
                }

                _addedSecHash[moduleValue] = module;
            } else {
                window.RapidInstance.refreshModule(moduleId);
            }
        }

        if (Object.keys(activateQueue).length > 0) {
            window.RapidInstance.addModules(activateQueue, false);
        }

        if (Object.keys(activateViewabilityQueue).length > 0) {
            window.RapidInstance.addModules(activateViewabilityQueue, false, {
                useViewability: true
            });
        }

        if (
            window.RapidInstance.addModuleProgression &&
            (activateQueue['entry-text'] || activateViewabilityQueue['entry-text'])
         ) {
            window.RapidInstance.addModuleProgression('entry-text');
        }

        // clear the queue
        _secQueue = {};
    }

    /**
     * Convert `data-ylk` value into an object. Ex: "subsec:menu;slk:topic".
     * @param {string} ylkData
     * @private
     */
    function _ylkToObject(ylkData) {
        var ylks = ylkData.split(';');
        var ylkObject = {};

        ylks.forEach(function (ylk) {
            var ylkSplit = ylk.split(':');

            if (ylkSplit[0]) {
                ylkObject[ylkSplit[0]] = ylkSplit[1] || null;
            }
        });

        return ylkObject;
    }

    /**
     * Convert an object into `data-ylk` string value.
     * @param {object} ylkObject
     * @private
     */
    function _objectToYlk(ylkObject) {
        var ylks = [];

        Object.keys(ylkObject).forEach(function (key) {
            ylks.push(key + ':' + ylkObject[key]);
        });

        return ylks.join(';');
    }

    /**
     * Find `sec` in which an element is grouped
     * @param {jQuery} $element
     * @return object
     * @private
     */
    function _findSec($element) {
        var $secElement = $element.closest('[data-rapid-sec]');

        if ($secElement.length === 0) return null;

        var secObject = $secElement.data('rapid-sec');

        return secObject;
    }

    /**
     * Find `sec` in which an element is grouped
     * @param {jQuery} $element
     * @return string
     * @private
     */
    function _findSubSec($element) {
        var $subsecElement = $element.parents('[data-rapid-subsec]');

        return $subsecElement.length > 0 ? $subsecElement.data('rapid-subsec') : '';
    }

    /**
     * Track an element as `sec` by assigning element id so Rapid can identify
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addSecToElement($element, value) {
        if (!$element.data('rapid-sec')) {
            var moduleObject = {};

            if ($element.attr('id')) {
                // If a element already has an ID, we'll keep it and use that id as module hash key
                moduleObject[$element.attr('id')] = value;
            } else {
                $element.attr('id', value);
                moduleObject[value] = value;
            }

            $element.attr('data-rapid-sec', JSON.stringify(moduleObject));

            _addSecToQueue(moduleObject);
        }
    }

    /**
     * Identity an element as `subsec`
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addSubSecToElement($element, value) {
        if (!$element.data('rapid-subsec')) {
            $element.attr('data-rapid-subsec', value);

            var $trackedElements, $trackedElement;

            $trackedElements = $element.find('.yr-track, a');

            $trackedElements.each(function (idy, trackedElement) {
                $trackedElement = $(trackedElement);

                _addYlkToElement($trackedElement, {
                    subsec: value
                });
            });
        }
    }

    /**
     * Add `cpos` and `pos` property as position identifier of each element and add them to `data-ylk` of tracked links.
     * @param {jQuery} $children
     * @private
     */
    function _addCposToChildren($children) {
        var cpos, pos, $element, $trackedElements, $trackedElement;

        $children.each(function (idx, child) {
            cpos = idx + 1;
            $element = $(child);
            $element.attr('data-rapid-cpos', cpos);

            $trackedElements = $element.find('.yr-track, a');

            $trackedElements.each(function (idy, trackedElement) {
                pos = idy + 1;
                $trackedElement = $(trackedElement);
                $trackedElement.attr('data-rapid-pos', pos);

                _addYlkToElement($trackedElement, {
                    cpos: cpos,
                    pos: pos
                });
            });
        });
    }

    /**
     * Add `slk` property to `data-ylk` Rapid tracking.
     *
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addSlkToElement($element, value) {
        if (!$element.data('rapid-slk')) {
            var ylk = {};

            if (typeof value !== 'undefined') {
                $element.attr('data-rapid-slk', value);

                ylk['slk'] = value;
            }

            _addYlkToElement($element, ylk);
        }
    }

    /**
     * Add `elm` property to `data-ylk` Rapid tracking.
     *
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addElmToElement($element, value) {
        if (!$element.data('rapid-elm')) {
            $element.attr('data-rapid-elm', value);

            var ylk = {
                elm: value
            };

            _addYlkToElement($element, ylk);
        }
    }

    /**
     * Add `g` property to `data-ylk` Rapid tracking.
     *
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addGToElement($element, value) {
        if (!$element.data('rapid-g')) {
            $element.attr('data-rapid-g', value);

            var ylk = {
                g: value
            };

            _addYlkToElement($element, ylk);
        }
    }

    /**
     * Add `itc` property to `data-ylk` Rapid tracking.
     *
     * @param {jQuery} $element
     * @param {string|number} value
     * @private
     */
    function _addItcToElement($element, value) {
        if (!$element.data('rapid-itc')) {
            $element.attr('data-rapid-itc', value);

            var ylk = {
                itc: value
            };

            _addYlkToElement($element, ylk);
        }
    }

    /**
     * Add key-value pair(s) object to `data-ylk` attribute.
     * Will merge-replace with existing `data-ylk`.
     *
     * @param {jQuery} $element
     * @param {object} ylkData
     * @private
     */
    function _addYlkToElement($element, ylk) {
        var sec = $element.data('rapid-sec');

        if (!sec) {
            sec = _findSec($element);
        }

        var currentYlk = _ylkToObject($element.attr('data-ylk') || '');

        var mergedYlk = Object.assign(currentYlk, ylk);

        $element.attr('data-ylk', _objectToYlk(mergedYlk));

        // `sec` where this element is must be refreshed to track this change
        if (sec) {
            // Memoize `sec`
            $element.attr('data-rapid-sec', JSON.stringify(sec));
            _addSecToQueue(sec);
        }
    }

    /**
     * Parse single element
     * @param {jQuery} $element
     * @param {object} elementConfig
     * @private
     */
    function _parseElement($element, elementConfig) {
        var value = elementConfig.value;

        if (!value && elementConfig.valueFromAttribute) {
            value = $element.attr(elementConfig.valueFromAttribute);
        }

        switch (elementConfig.type) {
            case 'sec':
                _addSecToElement($element, value);
                break;
            case 'subsec':
                _addSubSecToElement($element, value);
                break;
            case 'elm':
                _addElmToElement($element, value);
                break;
            case 'slk':
                _addSlkToElement($element, value);
                break;
            case 'itc':
                _addItcToElement($element, value);
                break;
            case 'g':
                _addGToElement($element, value);
                break;
        }

        // Add `cpos` to every child of `sec` and `subsec` which has `childrenSelector` configured
        if (['sec', 'subsec'].indexOf(elementConfig.type) >= 0) {
            if (elementConfig.childrenSelector) {
                var $children = $element.find(elementConfig.childrenSelector);

                _addCposToChildren($children);
            }
        }
    }

    /**
     * Rapid track interaction and linkview inside context
     *
     * @param {any} [selector='body']
     * @param {array|object} [elementConfigs=] array or set
     */
    function trackElements(selector, elementConfigs) {
        if (!window.RapidInstance) {
            console.error('Rapid is not instantiated.');

            return false;
        }

        if (elementConfigs && !Array.isArray(elementConfigs)) {
            console.error('Rapid element configs must be array.');

            return false;
        }

        if (!elementConfigs) {
            elementConfigs = _elementConfigsHash;
        }

        if (!selector) {
            selector = 'body';
        }

        var $selector = $(selector);

        var elementConfig, $elements;
        for (var i in elementConfigs) { // jshint ignore:line
            elementConfig = elementConfigs[i];

            _storeElementConfig(elementConfig);

            if (!_validateElementConfig(elementConfig)) continue;

            // Start looking from parent to include the selector itself
            $elements = $selector.parent().find(elementConfig.selector);

            $elements.each(function (idx, element) { // jshint ignore:line
                _parseElement($(element), elementConfig);
            });
        }

        setTimeout(function() {
            _registerModules();
        }, 500);
    }

    /* global MW */
    MW.modules.rapid = {
        trackElements: trackElements
    };
})(jQuery);
